export default __webpack_public_path__ + "static/media/rocket.16819864.png";